<template>
  <div>
    <MenuMovilTP />
    <MenuMovilUni />
    <main class="container dkt mb-4 px-0 px-md-3 fc">
      <Titulo
        :titulo2="institucion.nombreCorto"
        tipoEncabezado="FICHA_UNIVERSIDAD"
        :volverA="origenRedirect"
        :datosContacto="datosContactame"
        @descargar="descargarFicha"
      />
      <div class="col mb-3 px-0">
        <Iconos :institucion="institucion" tipoInstitucion="UNIVERSIDAD" />
        <DetallesInstitucion
          :institucion="institucion"
          tipoInstituto="UNIVERSIDAD"
        />
      </div>
    </main>
  </div>
</template>

<script>
import Busqueda from "@/utils/Busqueda.js";
import Titulo from "@/components/generales/paginas/TituloFicha";
import ApiUniversidades from "@/services/ApiUniversidades";
import Iconos from "@/components/fichaInstitucion/Iconos";
import DetallesInstitucion from "@/components/fichaInstitucion/DetallesInstitucion";
import MenuMovilTP from "@/components/generales/menuMovil/TecnicoProfesional";
import MenuMovilUni from "@/components/generales/menuMovil/AdmisionUniversitaria";
import { PdfDocument } from "@/utils/ConstructorPDF.js";
import MixinsIconos from "@/mixins/iconosInstituciones.js";

export default {
  name: "FichaInstitucion",
  components: {
    Titulo,
    Iconos,
    DetallesInstitucion,
    MenuMovilTP,
    MenuMovilUni
  },
  mixins: [MixinsIconos],
  data() {
    return {
      institucion: {},
      origenRedirect: ""
    };
  },
  created() {
    this.getDatosFicha();
  },
  computed: {
    tipoInstitucion() {
      return this.limpiarNombreTipoInstitucion(
        this.institucion.tipoInstitucion
      );
    },
    datosContactame() {
      let datosContacto = {
        codigoIntitucion: this.institucion.codigo
      };
      return datosContacto;
    }
  },
  methods: {
    async getDatosFicha() {
      this.$emit("cargar");
      let idInstitucion = this.$route.params.idInstitucion;
      this.origenRedirect = this.$route.params.origen;
      let data = await ApiUniversidades.getFichaInstitucion(
        idInstitucion,
        true
      );
      if (data) {
        this.institucion = data;
      }
      this.$emit("cargado");
    },
    limpiarNombreTipoInstitucion(texto) {
      return Busqueda.limpiarNombreTipoInstitucion(texto);
    },
    descargarFicha() {
      let nombreDocumento = this.institucion.nombreCorto;

      let titulo = {
        institucion: this.institucion.nombreCorto
      };
      let iconos = {
        tipoInstitucion: "UNIVERSIDAD",
        logoInstitucion: this.getBase64Image(this.institucion.logoBase64),
        acreditacionInstitucional: this.textoAcreditacion(
          "UNIVERSIDAD",
          this.institucion.acreditado,
          this.institucion.acreditacion.anios,
          this.institucion.observacionAcreditacionCNA
        ),
        periodoAcreditacion: this.institucion.acreditacion.periodo,
        areasAcreditadas:
          this.institucion.areasAcreditadas &&
          this.institucion.areasAcreditadas.length > 0
            ? this.institucion.areasAcreditadas.slice()
            : ["Sin áreas acreditadas"],
        matriculaPregrado: this.institucion.matriculaTotalPregrado,
        matriculaPostgrado: this.institucion.matriculaTotalPostgrado,
        beneficiosEstatales: this.institucion.beneficiosEstatales,
        presenciaRegional: this.institucion.presenciaRegional.slice(),
        observacionAcreditacionCNA: this.institucion.observacionAcreditacionCNA,
        acreditacionEspecialPandemiaCNA:
          this.institucion.acreditado &&
          this.institucion.acreditacion.anios === 0
      };
      PdfDocument.init();
      PdfDocument.setTitulo("UNIVERSIDAD", titulo);
      PdfDocument.setIconosInstituciones(iconos);
      PdfDocument.setDisclaimersAdicionales(
        iconos.observacionAcreditacionCNA,
        iconos.acreditacionEspecialPandemiaCNA,
        "UNIVERSIDAD"
      );
      PdfDocument.setServiciosEstudiantiles(
        this.institucion.serviciosEstudiantiles,
        "UNIVERSIDAD"
      );
      PdfDocument.setInfraestructuraEquipamiento(
        this.institucion.infraestructurasEquipamientos
      );
      PdfDocument.openSinglePage(nombreDocumento);
      PdfDocument.reset();
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/pages/BuscadoresU/FichaInstitutoU.vue